import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["required", "disabled"]
const _hoisted_2 = { class: "form-check" }
const _hoisted_3 = ["name"]
const _hoisted_4 = { class: "form-check ms-5" }
const _hoisted_5 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectField = _resolveComponent("SelectField")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'hstack':_ctx.isHorizontal}, "gap-2 position-relative"]),
    required: _ctx.isRequired ? true : null,
    disabled: _ctx.isDisabled ? true : null
  }, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        name: `flexRadioDefault${_ctx.index}`,
        type: "radio",
        class: "",
        value: "exact",
        required: "true",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectionMode) = $event))
      }, null, 8, _hoisted_3), [
        [_vModelRadio, _ctx.selectionMode]
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-check-label" }, "Exact:", -1))
    ]),
    _createVNode(_component_SelectField, {
      modelValue: _ctx.exactAge,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.exactAge) = $event)),
      ref: "exactAgeSelect",
      "select-items": _ctx.ageSelectItems,
      "is-horizontal": false,
      "is-disabled": _ctx.selectionMode == 'range',
      "is-required": _ctx.isRequired && _ctx.selectionMode == 'exact',
      style: {"min-width":"150px"}
    }, null, 8, ["modelValue", "select-items", "is-disabled", "is-required"]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        name: `flexRadioDefault${_ctx.index}`,
        type: "radio",
        class: "",
        value: "range",
        required: "true",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectionMode) = $event))
      }, null, 8, _hoisted_5), [
        [_vModelRadio, _ctx.selectionMode]
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-check-label" }, "Range:", -1))
    ]),
    _createVNode(_component_SelectField, {
      modelValue: _ctx.minAge,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.minAge) = $event)),
      ref: "minAgeSelect",
      "select-items": _ctx.minAgeSelectItems,
      "is-horizontal": false,
      "is-disabled": _ctx.selectionMode == 'exact',
      "is-required": _ctx.isRequired && _ctx.selectionMode == 'range',
      style: {"min-width":"150px"}
    }, {
      label: _withCtx(() => [...(_cache[7] || (_cache[7] = [
        _createElementVNode("label", {
          class: "position-absolute",
          style: {"top":"-25px"}
        }, "Min:", -1)
      ]))]),
      _: 1
    }, 8, ["modelValue", "select-items", "is-disabled", "is-required"]),
    _createVNode(_component_SelectField, {
      modelValue: _ctx.maxAge,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.maxAge) = $event)),
      ref: "maxAgeSelect",
      "select-items": _ctx.maxAgeSelectItems,
      "is-horizontal": false,
      "is-disabled": _ctx.selectionMode == 'exact',
      "is-required": _ctx.isRequired && _ctx.selectionMode == 'range',
      style: {"min-width":"150px"}
    }, {
      label: _withCtx(() => [...(_cache[8] || (_cache[8] = [
        _createElementVNode("label", {
          class: "position-absolute",
          style: {"top":"-25px"}
        }, "Max:", -1)
      ]))]),
      _: 1
    }, 8, ["modelValue", "select-items", "is-disabled", "is-required"])
  ], 10, _hoisted_1))
}